// extracted by mini-css-extract-plugin
export default {"timerBg":"CountDownTimer_timerBg__38Mm+"};